import { Alert, Stack } from '@mui/material';
import React from 'react'

const AlertBox = ({ isActivePlan, message }) => {
  return (
    <div>
      <Stack sx={{ width: '100%', marginTop: '10px' }} spacing={2}>
        {isActivePlan ? (
          <Alert variant="filled" severity="warning">
            {message}
          </Alert>
        ) : null}
      </Stack>
    </div>
  )
}

export default AlertBox;